const SUCCESSFUL_REQUEST_STATUSES = new Set(['allocated', 'confirmed']);

function normalizeToQuarterHour(value) {
  const match = String(value || '').trim().match(/^(\d{1,2}):(\d{2})$/);
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
  const rounded = Math.min(23 * 60 + 45, Math.round((hours * 60 + minutes) / 15) * 15);
  return `${String(Math.floor(rounded / 60)).padStart(2, '0')}:${String(rounded % 60).padStart(2, '0')}`;
}

function dateMillis(value) {
  const date = value?.toDate?.() || (value instanceof Date ? value : value ? new Date(value) : null);
  const millis = date?.getTime?.();
  return Number.isFinite(millis) ? millis : 0;
}

export function preferredBoatStartTime(requests = [], fallback = '08:00', minimumSamples = 2) {
  const successful = (Array.isArray(requests) ? requests : [])
    .filter(request => SUCCESSFUL_REQUEST_STATUSES.has(String(request?.status || '').toLowerCase()))
    .map(request => ({
      time: normalizeToQuarterHour(request?.fromTime),
      date: dateMillis(request?.date)
    }))
    .filter(request => request.time);

  if (successful.length < minimumSamples) return fallback;

  const totals = new Map();
  successful.forEach(request => {
    const current = totals.get(request.time) || { count: 0, latest: 0 };
    totals.set(request.time, {
      count: current.count + 1,
      latest: Math.max(current.latest, request.date)
    });
  });

  return Array.from(totals.entries()).sort((left, right) => {
    if (right[1].count !== left[1].count) return right[1].count - left[1].count;
    if (right[1].latest !== left[1].latest) return right[1].latest - left[1].latest;
    return left[0].localeCompare(right[0]);
  })[0]?.[0] || fallback;
}
